


















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CheckIcon, UserIcon, XIcon } from 'vue-feather-icons';
import { IUser, UserStatus } from 'admiral-core';
import Avatar from '@/components/common/Avatar.vue';

@Component({
  name: 'CustomerBetreuerFilter',
  components: { Avatar, CheckIcon, UserIcon, XIcon },
})
export default class CustomerBetreuerFilter extends Vue {
  @Prop({ type: Array, default: () => [] })
  betreuerFilter!: IUser[];

  @Prop({ type: Array, default: () => [] })
  users!: IUser[];

  hovered = false;

  /** Nur aktive Mitarbeiter, alphabetisch nach Nachname. */
  get sortedUsers(): IUser[] {
    return this.users
      .filter((user) => user.status === UserStatus.ACTIVE)
      .sort((a, b) => this.labelUser(a).localeCompare(this.labelUser(b), 'de-DE'));
  }

  get displayLabel(): string {
    if (this.betreuerFilter.length === 0) {
      return 'Alle Mitarbeiter';
    }
    if (this.betreuerFilter.length === 1) {
      return this.labelUser(this.betreuerFilter[0]);
    }
    return `${this.labelUser(this.betreuerFilter[0])} + ${this.betreuerFilter.length - 1}`;
  }

  labelUser(user: IUser): string {
    if (!user.lastname) {
      return user.firstname || '';
    }
    if (!user.firstname) {
      return user.lastname;
    }
    return `${user.lastname}, ${user.firstname}`;
  }

  isSelected(userId: string): boolean {
    return this.betreuerFilter.some((user) => user.id === userId);
  }

  /** Schaltet einen Mitarbeiter im Mehrfachfilter. */
  toggleUser(user: IUser) {
    const newFilter = this.isSelected(user.id)
      ? this.betreuerFilter.filter((item) => item.id !== user.id)
      : [...this.betreuerFilter, user];
    this.$emit('update:betreuerFilter', newFilter);
  }

  clearFilter() {
    this.$emit('update:betreuerFilter', []);
  }
}
